import { graphql, PageProps } from 'gatsby'
import { IPostNode } from '../types/postsListing'
import Layout from '../components/Layout'
import Container from '../components/container'
import GraphQLErrorList from '../components/graphql-error-list'
import PaginatedContent from '../containers/PaginatedContent'
import SectionHero from '../components/SectionHero'
import BlogSubMenu from '../components/BlogSubMenu'
import SEO from '../components/seo'

interface CategoryProps {
  title: string
  name?: string
  description: string
  posts: IPostNode[]
}

export const query = graphql`
  query CategoryTemplate($id: String!) {
    category: sanityCategory(id: { eq: $id }) {
      title
      name
      description
      posts {
        id
        categories {
          id
          title
          name
          slug {
            current
          }
        }
        publishedAt
        mainImage {
          ...SanityImage
          alt
        }
        title
        excerpt
        slug {
          current
        }
        authors {
          author {
            id
            name
            image {
              ...SanityImage
              alt
            }
          }
        }
      }
    }
  }
`
function CategoryPostTemplate({
  data,
  errors,
}: {
  data: { category: CategoryProps }
  errors: Error[]
}) {
  if (errors) {
    return (
      <Layout>
        <GraphQLErrorList errors={errors} />
        {!data.category && <p>No category data</p>}
      </Layout>
    )
  }

  const { title, name, posts } = data.category || {}

  const sortedPostsByDate = posts.sort(
    (a, b) => +new Date(b.publishedAt) - +new Date(a.publishedAt),
  )

  return (
    <Layout>
      <SectionHero
        title="Data Science Educational Resources"
        description="StrataScratch is a data science educational platform with over 1,000+
        real interview questions from your favorite companies."
      />
      <Container>
        <BlogSubMenu />
        {posts && posts.length > 0 && (
          <PaginatedContent
            title={title}
            name={name}
            posts={sortedPostsByDate}
          />
        )}
      </Container>
    </Layout>
  )
}

export function Head({ data }: PageProps<Queries.CategoryTemplateQuery>) {
  return (
    <SEO
      title={data.category?.title || ''}
      description={data.category?.description || ''}
    />
  )
}

export default CategoryPostTemplate
